import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

function Chi() {
  useEffect(() => {
    document.title = "lo ha fatto?";
  }, []);

  return (
    <div className="App">
      <h1>CHI?</h1>
    </div>
  );
}

function No() {
  useEffect(() => {
    document.title = "Fonzie ha scopato oggi?";
  }, []);

  return (
    <div className="App">
      <h1>NO</h1>
    </div>
  );
}

function NoDavide() {
  useEffect(() => {
    document.title = "Davide ha scopato oggi?";
  }, []);

  return (
    <div className="App">
      <h1>NO</h1>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/fonzieoggihascopato" element={<No />} />
        <Route path="/davideoggihascopato" element={<NoDavide />} />
        <Route path="*" element={<Chi />} />
      </Routes>
    </Router>
  );
}

export default App;
